import { Link } from "react-router-dom";

export default function SectionHeading({
  eyebrow,
  title,
  description,
  linkTo,
  linkLabel = "查看全部",
}: {
  eyebrow?: string;
  title: string;
  description?: string;
  linkTo?: string;
  linkLabel?: string;
}) {
  return (
    <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8">
      <div>
        {eyebrow && (
          <span className="inline-flex items-center gap-2 text-xs font-label text-primary-700 mb-3">
            <span className="w-6 h-px bg-primary-500" />
            {eyebrow}
          </span>
        )}
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-2">{title}</h2>
        {description && <p className="text-sm text-foreground-500 max-w-2xl leading-relaxed">{description}</p>}
      </div>
      {linkTo && (
        <Link
          to={linkTo}
          className="inline-flex items-center gap-1.5 text-sm font-label text-accent-700 hover:text-primary-600 whitespace-nowrap transition-colors"
        >
          {linkLabel}
          <i className="ri-arrow-right-line" />
        </Link>
      )}
    </div>
  );
}